import { render, staticRenderFns } from "./ViewDetailBiometric.vue?vue&type=template&id=4b33b040"
import script from "./ViewDetailBiometric.vue?vue&type=script&lang=js"
export * from "./ViewDetailBiometric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports